import styled from "styled-components";
import { noop } from "lodash";
import { Upload } from "antd";
import { RATypography } from "../Typography";
import { SvgPaperClip } from "@/assets/icons";
import { MessageFile } from "./MessageFile";
import { NOTIFICATION_TYPE } from "@/config/constants";
import { toast } from "@/modules/toast";

export const UPLOAD_FILE_ACCEPT = ".jpeg, .jpg, .png, .pdf";

export const RAUploadFiles = ({ value, title, description = "", onChange = noop }) => {
	const handleClearFile = (fid) => {
		const fss = value.filter((f) => f.uid !== fid);
		onChange(fss);
	};

	const beforeUpload = (file) => {
		const isLt10M = file.size / 1024 / 1024 < 10;
		if (!isLt10M) {
			toast({
				type: NOTIFICATION_TYPE.WARNING,
				description: "File must be smaller than 10MB!",
			});
			return Upload.LIST_IGNORE; // Prevent upload if the file size is greater than 10MB
		}

		return false; // Return true if all checks pass
	};

	return (
		<WrapperInput>
			{title && (
				<WrapperTitle>
					<RATypography color="#595959" variant="sub-heading4">
						{title}
					</RATypography>
				</WrapperTitle>
			)}
			<Upload
				fileList={value}
				beforeUpload={beforeUpload}
				showUploadList={false}
				multiple
				onChange={({ fileList }) => {
					onChange(fileList);
				}}
				accept={UPLOAD_FILE_ACCEPT}
				style={{ width: "100%" }}
			>
				<WrapperUpload>
					<SvgPaperClip />
					<RATypography color="#222222" variant="sub-heading4">
						File Upload
					</RATypography>
					{description ? (
						<RATypography color="#595959" variant="sub-heading5">
							{description}
						</RATypography>
					) : null}
				</WrapperUpload>
			</Upload>
			<div
				gap={8}
				style={{
					display: "flex",
					alignItems: "center",
					marginTop: 12,
					overflow: "auto hidden",
				}}
			>
				{value.map((fs) => (
					<MessageFile file={fs} key={fs.uid} isInput={true} onClear={() => handleClearFile(fs.uid)} />
				))}
			</div>
		</WrapperInput>
	);
};

const WrapperInput = styled.div`
	.ant-upload .ant-upload-select {
		width: 100%;
	}

	.ant-upload-wrapper .ant-upload-select {
		width: 100% !important;
	}
`;

const WrapperTitle = styled.div`
	padding-bottom: 8px;
`;

const WrapperUpload = styled.div`
	width: 100%;
	border: 1px dashed #a8a8a8;
	padding: 20px;
	border-radius: 12px;
	min-height: 60px;
	display: flex;
	align-items: center;
	gap: 16px;
	cursor: pointer;
`;
